<!--
  NotificationToast.vue — Komponent do wyświetlania powiadomień toast.
  Montowany globalnie w App.vue, wyświetla powiadomienia z useNotification.
-->
<template>
  <Teleport to="body">
    <div class="toast-container">
      <TransitionGroup name="toast">
        <div v-for="n in notifications" :key="n.id"
             class="toast" :class="n.type"
             @click="dismiss(n.id)">
          <span class="toast-icon">
            {{ n.type === 'success' ? '✓' : n.type === 'error' ? '✕' : n.type === 'warning' ? '⚠' : 'ℹ' }}
          </span>
          <span class="toast-message">{{ n.message }}</span>
        </div>
      </TransitionGroup>
    </div>
  </Teleport>
</template>

<script setup lang="ts">
import { useNotification } from '@/composables/useNotification'

const { notifications, dismiss } = useNotification()
</script>

<style scoped>
.toast-container {
  position: fixed;
  top: 1rem;
  right: 1rem;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  max-width: 360px;
}

.toast {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.6rem 1rem;
  border-radius: 6px;
  font-size: 0.9rem;
  cursor: pointer;
  backdrop-filter: blur(8px);
  border: 1px solid;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
}
.toast.success { background: rgba(16, 185, 129, 0.15); border-color: #10b981; color: #34d399; }
.toast.error   { background: rgba(239, 68, 68, 0.15); border-color: #ef4444; color: #f87171; }
.toast.info    { background: rgba(72, 156, 214, 0.15); border-color: #489cd6; color: #7dd3fc; }
.toast.warning { background: rgba(245, 158, 11, 0.15); border-color: #f59e0b; color: #fbbf24; }

.toast-icon { font-weight: bold; font-size: 1rem; flex-shrink: 0; }
.toast-message { flex: 1; }

/* Animacje TransitionGroup */
.toast-enter-active { animation: toastIn 0.25s ease; }
.toast-leave-active { animation: toastOut 0.2s ease; }
.toast-move { transition: transform 0.2s ease; }

@keyframes toastIn {
  from { opacity: 0; transform: translateX(100%); }
  to { opacity: 1; transform: translateX(0); }
}
@keyframes toastOut {
  from { opacity: 1; transform: translateX(0); }
  to { opacity: 0; transform: translateX(100%); }
}
</style>
